var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('comision-data-card',{attrs:{"cuota":_vm.cuota}}),_c('desglose-comision-card',{attrs:{"cuota":_vm.cuota}}),_c('facturacion-comision-card',{attrs:{"cuota":_vm.cuota}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }